<template>
  <transition mode="out-in">
    <router-view v-if="isRouterAlive"></router-view>
  </transition>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        isRouterAlive: true
      }
    },
  }

</script>

<style lang="less">
  @import './style/common';

</style>



// WEBPACK FOOTER //
// src/App.vue